var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as angular from 'angular';
import { reloadCurrentRoute } from '../../../../../../src/app/shared/utils/navigate-force-reload';
var Receive = /** @class */ (function () {
    function Receive(InboundNumbersService, $stateParams, $state, Toast, $http, Router) {
        this.InboundNumbersService = InboundNumbersService;
        this.$stateParams = $stateParams;
        this.state = $state;
        this.toast = Toast;
        this.router = Router;
    }
    Receive.prototype.$onInit = function () {
        this.settings = angular.copy(this.settings);
        this.msisdnId = this.msisdnid;
    };
    Receive.prototype.save = function () {
        var _this = this;
        this.settings = __assign({}, this.settings, { checked: true });
        this.InboundNumbersService.setNumberSettings({ id: this.msisdnid }, { receiveCallConfiguration: this.settings, missedCallStrategy: this.settings.missedCallStrategy }, function () {
            _this.hide();
            _this.toast.success('CHANGES_SAVED');
            reloadCurrentRoute(_this.router);
        });
    };
    Receive.prototype.onMessageUpdate = function () {
        var _this = this;
        this.InboundNumbersService.getNumberSettings({ id: this.msisdnid }, function (settings) {
            _this.settings.agentNotLoggedInStrategy.voicemailMessageFile = settings.receiveCallConfiguration.agentNotLoggedInStrategy.voicemailMessageFile;
            _this.settings.agentNotLoggedInStrategy.promptMessageFile = settings.receiveCallConfiguration.agentNotLoggedInStrategy.promptMessageFile;
        });
    };
    Receive.prototype.onChangeAgentOnline = function (event) {
        this.settings.agentLoggedInStrategy.inboundHandlingStrategyType = event.state;
    };
    Receive.$inject = ['InboundNumbersService', '$stateParams', '$state', 'Toast', '$http', 'Router'];
    return Receive;
}());
export default {
    controller: Receive,
    template: require('./phone.details.receive.html'),
    bindings: {
        hide: '&',
        settings: '<',
        msisdnid: '<'
    }
};
